import { render, staticRenderFns } from "./contactList.vue?vue&type=template&id=0021e3db&scoped=true&"
import script from "./contactList.vue?vue&type=script&lang=babel&"
export * from "./contactList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021e3db",
  null
  
)

export default component.exports